module.exports = __webpack_public_path__ + "static/img/bg-ar.2edc7a39.webp";